var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTables(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_hierarchy-3",
    "data-name": "vuesax/outline/hierarchy-3",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hierarchy-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75,7.5A3.75,3.75,0,1,1,7.5,3.75,3.751,3.751,0,0,1,3.75,7.5Zm0-6A2.25,2.25,0,1,0,6,3.75,2.253,2.253,0,0,0,3.75,1.5Z",
    transform: "translate(173.25 253.25)",
    fill: "#5b3061"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.75,7.5A3.75,3.75,0,1,1,7.5,3.75,3.751,3.751,0,0,1,3.75,7.5Zm0-6A2.25,2.25,0,1,0,6,3.75,2.253,2.253,0,0,0,3.75,1.5Z",
    transform: "translate(187.25 260.25)",
    fill: "#5b3061"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.75,7.5A3.75,3.75,0,1,1,7.5,3.75,3.751,3.751,0,0,1,3.75,7.5Zm0-6A2.25,2.25,0,1,0,6,3.75,2.253,2.253,0,0,0,3.75,1.5Z",
    transform: "translate(173.25 267.25)",
    fill: "#5b3061"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M.75,9.5A.755.755,0,0,1,0,8.75v-8A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75C1.5,2.94,2.56,4,4.75,4h7a.75.75,0,0,1,0,1.5h-7A4.971,4.971,0,0,1,1.5,4.49V8.75A.755.755,0,0,1,.75,9.5Z",
    transform: "translate(176.25 259.25)",
    fill: "#5b3061"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(172 252)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTables);
export default __webpack_public_path__ + "static/media/Icon-tables.31bed0b22be96c43b9ba27faac0423f5.svg";
export { ForwardRef as ReactComponent };